<template>
  <div :id="!!id.length ? id : null" class="price-listing">
    <div class="price-listing__content">
      <div class="container">
        <price-listing
            :show-load-more="showLoadMore"
            :items="filtered"
            :title="title"
            :intro="intro"
            :filters="filters"
            :trigger-filter="triggerFilter"
            :active-filter="activeFilter"
            :room-features="roomFeatures"
            :short-stay-filter-label="shortStayFilterLabel"
            :long-stay-filter-label="longStayFilterLabel"
        >
          <template slot="item" slot-scope="{ item }">
            <div class="push-v--desktop--small push-v--tablet--medium push-v--mobile--medium">
              <mini-card :images="item.images" :room="item.title" :content-codename="item.contentCodename" :type="item.type" :booking-type="activeFilter">
                <template slot="details">
                  <rooms-pricing-details :open-gallery="openGallery" v-bind="item" :cta-link-text="ctaLinkText" :view-details-text="viewDetailsText" :booking-type="activeFilter" />
                </template>
              </mini-card>
            </div>
          </template>
        </price-listing>
      </div>
    </div>
    <Gallery />
  </div>
</template>

<script>
import { forceObject } from '~/utils/processor';
import getStatic from '~/utils/get-static';
import PriceListing from './PriceListing';
import RoomsPricingDetails from '~/components/components/RoomsPricingDetails';
import MiniCard from '~/components/components/MiniCard';
import Gallery from '~/components/components/Gallery';

export default {
  components: {
    PriceListing,
    MiniCard,
    RoomsPricingDetails,
    Gallery,
  },
  props: {
    id: { type: String, default: 'rooms-and-prices' },
    title: { type: String, default: 'Rooms & Prices' },
    intro: { type: String, default: '<p>It’s your home, your workplace and your playground, so we’ve created one hassle-free monthly bill that takes care of everything you need.</p>' },
    filters: {
      type: Array,
      default() {
        return [];
      },
    },
    items: {
      type: Array,
      required: true,
      default() {
        return [
          { images: [
            {
              url: getStatic('/images/content/locations/test-slide-1.jpg'),
              description: 'Test slide 1',
            },
            {
              url: getStatic('/images/content/locations/test-slide-2.jpg'),
              description: 'Test slide 2',
            },
          ] },
        ];
      },
    },
    ctaLinkText: { type: String, default: 'Book now' },
    viewDetailsText: { type: String, default: 'View details' },
    roomFeatures: { type: Array, default() {
      return [
        { icon: '',
          feature: '',
        },
      ];
    } },
    shortStayFilterLabel: { type: String, default: 'Stay (1-89 nights)' },
    longStayFilterLabel: { type: String, default: 'Live (3+ months)' },
  },
  data() {
    return {
      activeFilter: 'longStay',
      filtered: [],
      preppedItems: [],
      showLoadMore: false,
    };
  },
  // watch: {
  //   activeFilter(newValue, oldValue) {
  //     // TODO: Ajax requests will need to be fired off, when we add a load more

  //     const includesLocationFilter = this.filters.find((filter) => filter.contentCodename === 'long_stay');

  //     if (newValue !== oldValue) {
  //       const filter = newValue;
  //       this.filtered = this.preppedItems.filter((item) => {
  //         if (
  //           item.filters.indexOf(filter) > -1 ||
  //             (includesLocationFilter && item.filters.indexOf('shortLongStay') > -1)
  //         ) {
  //           return true;
  //         }

  //         return false;
  //       });
  //     }
  //   },
  // },
  mounted() {
    this.preppedItems = this.items.map((item) => {
      if (item.type) {
        const typeObj = forceObject(item.type);
        const locationObj = forceObject(item.location);

        return {
          ...item,
          filters: [typeObj.codename, locationObj.codename],
        };
      } else {
        return {
          ...item,
        };
      }

    });

    this.filtered = this.preppedItems;
  },
  methods: {
    triggerFilter(filter) {
      this.activeFilter = filter;
    },
    openGallery(contentCodename, bookingType, location) {
      const selectedRoom = this.items.find((item)=>item.contentCodename===contentCodename);
      const {
        images,
        title,
        facilities,
        maximumCapacity,
        longStayPriceText='',
        longStayButtonCtaDisplay,
        shortStayButtonCtaDisplay,
        longStayButtonCta,
        shortStayButtonCta,
        shortStayCtaLink,
        longStayCtaLink,
        longStayPrices,
        shortStayPriceText,
        shortStayPrices,
        shortStayDescription,
        longStayDescription,
        billsIncludedText,
        floorplan = [{}],
      } = selectedRoom;
      let ctaLabel; let description; let ctaLink = ''; let priceText; let prices;
      if (bookingType==='longStay') {
        ctaLabel = longStayButtonCta || longStayButtonCtaDisplay;
        ctaLink = longStayCtaLink;
        description = longStayDescription;
        priceText =longStayPriceText;
        prices=longStayPrices;

      } else if (bookingType==='shortStay') {
        ctaLabel = shortStayButtonCta || shortStayButtonCtaDisplay;
        ctaLink = shortStayCtaLink;
        description = shortStayDescription;
        priceText = shortStayPriceText;
        prices = shortStayPrices;
      }

      if (!!shortStayCtaLink && shortStayCtaLink.length > 0) {
        ctaLink = shortStayCtaLink;
      } else if (!!longStayCtaLink && longStayCtaLink.length > 0) {
        ctaLink = longStayCtaLink;
      }


      this.$modal.show('gallery', {
        images,
        title,
        facilities,
        maximumCapacity,
        isVisible: true,
        bookingType,
        ctaLabel,
        ctaLink,
        description,
        billsIncludedText,
        floorPlan: floorplan[0],
        priceText,
        prices,
        location,
        selectedRoom,
      });
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_generic-listing.scss';
@import '~/assets/scss/atomic/modules/_rooms-pricing.scss';
</style>
